/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';

export class ETransportModifVehicleHistoryVoModel extends JSONable {
  uuid: string | null = null;
  licensePlates: string | null = null;
  modificationDate: string | null = null;
  observations: string | null = null;
  declaringCompanyCode: string | null = null;
  declaringCompanyReference: string | null = null;
  isActive = false;
}
